(function () {

    var searchForms = document.querySelectorAll('[data-search]');

    // If we are above the nav breakpoint
    if (!searchForms) {
        return false;
    }

    searchForms.forEach(function (searchForm) {
        var input = searchForm.querySelector('[data-search-input]');
        var submit = searchForm.querySelector('[data-search-submit]');
        var submitIcon = searchForm.querySelector('[data-search-submit-trigger-icon]');
        var closeIcon = searchForm.querySelector('[data-search-submit-close-icon]');

        submitIcon.addEventListener('click', function (event) {
            searchOpenClickHanlder(searchForm, input, submitIcon, closeIcon);
        });

        closeIcon.addEventListener('click', function (event) {
            searchCloseClickHandler(searchForm, input, submitIcon, closeIcon);
        });

        input.addEventListener('keyup', function () {
            searchKeyDownHanlder(submitIcon, closeIcon, input);
        });
        
    });

    function searchOpenClickHanlder(pEl, pInput, pSubmitIcon, pCloseIcon) {
        pEl.classList.add('c-nav-search--is-active');
        pInput.focus();

        if (pInput.value === '') {
            pSubmitIcon.classList.add('h-is-hidden');
            pCloseIcon.classList.remove('h-is-hidden');
        }
    }

    // Submit the form if the input value is not empty or close it and reset icons display
    function searchCloseClickHandler(pEl, pInput, pSubmitIcon, pCloseIcon) {

        if (pInput.value !== '') {
            pEl.submit();
            pInput.value === '';
        } else {
            pInput.blur();
            pEl.classList.remove('c-nav-search--is-active');
        }

        pSubmitIcon.classList.remove('h-is-hidden');
        pCloseIcon.classList.add('h-is-hidden');
    }

    // Display or not the CLOSE icon or the SUBMIT icon if input value is empty or not
    function searchKeyDownHanlder(pSubmitIcon, pCloseIcon, pInput) {
        if (pInput.value === '') {
            if (pCloseIcon.classList.contains('h-is-hidden')) {
                pCloseIcon.classList.remove('h-is-hidden');
            }

            if (!pSubmitIcon.classList.contains('h-is-hidden')) {
                pSubmitIcon.classList.add('h-is-hidden');
            }

        } else {
            if (!pCloseIcon.classList.contains('h-is-hidden')) {
                pCloseIcon.classList.add('h-is-hidden');
            }

            if (pSubmitIcon.classList.contains('h-is-hidden')) {
                pSubmitIcon.classList.remove('h-is-hidden');
            }
        }
    }
}());
